import type { CSSProperties } from 'react';
import React from 'react';
import { useStoreState } from '../../store';
import type { TranslationKey } from '../../store/i18n/TranslationTypes';

interface LocalizedTextProps extends React.DOMAttributes<HTMLSpanElement> {
  token: TranslationKey;
  className?: string | undefined;
  style?: CSSProperties;
}

export const LocalizedText = ({ token, className, style, ...domAttributes }: LocalizedTextProps) => {
  const localizedText = useStoreState((state) => state.i18n.activeResources[token]);
  return (
    <span className={className} style={style} {...domAttributes}>
      {localizedText}
    </span>
  );
};
